import { render, staticRenderFns } from "./TagInputField.vue?vue&type=template&id=0ed9011e&"
import script from "./TagInputField.vue?vue&type=script&lang=js&"
export * from "./TagInputField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports